import type { RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ToiletFeederView from '../views/ToiletFeederView.vue'
import QuantumView from '../views/QuantumView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/toilet-feeder',
    name: 'toiletFeeder',
    component: ToiletFeederView,
  },
  {
    path: '/quantum',
    name: 'quantum',
    component: QuantumView,
  },
]

export default routes
